module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.fails.js
 **/